import React, { Component } from "react";
import { Row, Col } from 'react-bootstrap';
import Table from "react-bootstrap/Table";
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";
import Icons from '../../../../../icon';
import { ORDER_STATUS, CIRCUIT_STATUS } from '../../../../../../constants/external-constants';

export class AccessoryDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    displayAccessories = (accessories, currency) => {

        return accessories != null && accessories.length != 0
            ? accessories.map((item, i) => (

                <tr key={i}>
                    <td>{i == 0 ? <Translation translationKey="accessory" /> : null}</td>
                    <td>
                        <Row>
                            <Col xs={6} md={6} lg={6} className="request-details-sec-val">
                                {item.EquipmentModel}
                            </Col>
                            <Col xs={6} md={6} lg={6} className="request-details-sec-val">
                                {item.OrderCost.toFixed(2)} {currency}
                            </Col>
                        </Row>
                    </td>
                </tr>
            ))
            : null;
    }
    
    editRequest = (orderStatusId, endUserId, requestorId, path) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open);

        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (endUserId == employeeId) || (requestorId == employeeId);

        return editableRequest && isRequestOwner && !path;
    }

    render() {
        const { data, isWireline, openRequestModal, path } = this.props;
        const { Order: { RequestType: { RequestTypeID, RequestType }, OrderStatusId, EndUserId, RequestorId } } = data || {};
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                    {this.editRequest(OrderStatusId, EndUserId, RequestorId, path) ?  
                         <Icons
                         customClassName="pen-to-square"
                         name="pen-to-square"
                         size="20px"
                         containerClass="icon-circle-plus-container"
                         onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                         labelValue={"Update Order Request"}
                         labelClass="order-detail-edit-label"                                                              
                     />
                        : null 
                    }
                </h4>
                <div className="order-detail-location details-info">
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>

                    <div className="order-detail-number-container order-detail-gap-x80 mb-0">
                        <div className="order-title">
                            <Translation translationKey="capital_sr_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.ServiceRequestNumber? data.Order.ServiceRequestNumber : "N/A"}
                        </div>
                    </div>

                    {data.Order.IsRequestedInBehalf ?
                        <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                        : null}
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table> 
                        <tbody>
                            <tr>
                                <td className="mobile-number-label"><Translation translationKey="mobile_phone_number" /></td>
                                <td className="mobile-number-label">{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className={data.Subscription.CircuitStatus == CIRCUIT_STATUS.inService.name ? "status-inservice" : data.Subscription.CircuitStatus == CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{data.Subscription.CircuitStatus}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.PlanDetails.PlanName ?
                                    data.Subscription.PlanDetails.PlanName :
                                    <Translation translationKey="no_plan_available" />}</td>
                            </tr>
                          
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription && data.Subscription.CurrentSubscriptionModel ?
                                    data.Subscription.CurrentSubscriptionModel.EquipmentModel :
                                    <Translation translationKey="no_device_available" />} </td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="selected_accessory" /></h5>
                    <Table>
                        <tbody>
                            {this.displayAccessories(data.Subscription.Accessories, data.Subscription.PlanDetails.Currency.CurrencyName)}
                            {data.Subscription.MobileServiceModel
                                && data.Subscription.MobileServiceModel.length > 0 &&
                                <tr>
                                    <td><Translation translationKey="total_order_cost" /></td>
                                    <td>{`${data.Subscription.TotalOrderCost} ${data.Subscription.PlanDetails.Currency.CurrencyName}`}</td>
                                </tr>
                            }
                            <tr>
                                <td><Translation translationKey="country" /></td>
                                {data.BillingAddress.LocationId > 0 ? <td>{data.BillingAddress.CountryName}</td> : null}
                                {data.BillingAddress.OtherDeliveryAddressId > 0 ? <td>{data.OtherLocationCountry}</td> : null}
                            </tr>
                            <tr>
                                <td><Translation translationKey="delivery_address" /></td>
                                {data.BillingAddress.LocationId > 0 ? <td>{data.BillingAddress.DeliveryAddress}</td> : null}
                                {data.BillingAddress.OtherDeliveryAddressId > 0 ? <td>{data.BillingAddress.OtherDeliveryAddress}</td> : null}
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_case" /></td>
                                <td>{data.BusinessJustification.DetailName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                    {isWireline &&
                        <OrderRequestFiles files={data.Order.OrderFileNames} />
                    }
                </div>
            </div>
        );
    }
}